import React from "react";

import { AsyncComponent } from "@impero-com/common/components/asyncComponent";
import { LoggedInHTTPError } from "@impero-com/common/errorPages/loggedInHTTPError";
import { AjaxManager } from "@impero-com/common/utils/ajax";
import {
    formatDateTimeAndTimezone,
    formatUserName,
} from "@impero-com/common/utils/formatting";
import { PageSpinner } from "@impero-com/ui";

import { UserViewDto, IanaTimezoneView } from "api/generated/model";
import { getUsersUserId } from "api/generated/users/users";

import * as theme from "./theme.css";

class UserWithTimestampStatus extends React.Component<UserWithTimestampStatusProps> {
    render() {
        const { at, timezone, user, atHeader, userHeader, ajaxManager } =
            this.props;

        return (
            <AsyncComponent<UserViewDto>
                key="user-with-timestamp-status"
                promise={() => getUsersUserId(user)}
                renderLoading={() => <PageSpinner />}
                renderError={(code) => {
                    return <LoggedInHTTPError code={code} />;
                }}
                renderContent={(data) => {
                    const {
                        content: { resource: user },
                    } = data;
                    return (
                        <div className={theme.section}>
                            <div className={theme.sectionColumn}>
                                <h3 className={theme.header}>{atHeader}</h3>
                                {formatDateTimeAndTimezone(at, timezone)}
                            </div>
                            <div className={theme.sectionColumnSeparator} />
                            <div className={theme.sectionColumn}>
                                <h3 className={theme.header}>{userHeader}</h3>
                                {formatUserName(user)}
                            </div>
                        </div>
                    );
                }}
                ajaxManager={ajaxManager}
            />
        );
    }
}

interface UserWithTimestampStatusProps {
    ajaxManager: AjaxManager;

    user: number;
    at: string;
    timezone: IanaTimezoneView;

    atHeader: string;
    userHeader: string;
}

export default UserWithTimestampStatus;
